export enum ESidebarPosition {
  fixed = 0,
  float = 1
}
